import { ChartConfigurationProvider } from "@/contexts/ChartConfiguration";
import { DiscreteChartCard, SegementedProgressChartCard, UnknownChartCard } from "@/tpo/ChartCards";

export default function ResultCharts({ children, result }) {
  if (result.chartConfiguration?.chartType === "DISCRETE_CHART") {
    return (
      <ChartConfigurationProvider value={result.chartConfiguration}>
        <DiscreteChartCard result={result}>{children}</DiscreteChartCard>
      </ChartConfigurationProvider>
    );
  } else if (result.chartConfiguration?.chartType === "SEGMENTED_PROGRESS_CHART") {
    return (
      <ChartConfigurationProvider value={result.chartConfiguration}>
        <SegementedProgressChartCard result={result}>{children}</SegementedProgressChartCard>
      </ChartConfigurationProvider>
    );
  }

  return (
    <ChartConfigurationProvider value={result.chartConfiguration}>
      <UnknownChartCard result={result}>{children}</UnknownChartCard>
    </ChartConfigurationProvider>
  );
}
